const mutations = {
  setItem(state, { resource, payload, debug = false }) {
    state[resource] = payload;
    if (debug) {
      console.log("setItem debug", resource, payload, state[resource]);
    }
  },
  setSelectedSiteId(state, siteId) {
    state.selectedSiteId = siteId;
  }
};

export default mutations;
